export enum Gender {
    MALE = 'M',
    FEMALE = 'F',
    NOT_DEFINED = 'ND'
}
